'use client';

/**
 * Renders a BIP-39 recovery phrase as a numbered 3-column grid — one
 * cell per word, each prefixed with its 1-based index. Pure
 * presentation, no sync logic.
 *
 * B1 zine recipe (build 1504 redesign): flat paper-2 panel with a 1px
 * ink hairline border, square corners. Words sit directly on the cream
 * paper — no inner pill backgrounds, no rounding. Index numbers in
 * mono on over-num (the muted-red accent for numerals); words in mono
 * on ink. Matches the shared-card modal vocabulary (build 1493).
 *
 * Extracted from SyncPanel (build 1502) so the Settings "Data safety"
 * recovery-phrase modal and SyncPanel's show-new-phrase / show-phrase
 * flows share one rendering — three call sites tripped the design rule
 * "the same recipe in 3+ places → extract".
 */
export default function PhraseGrid({ phrase }: { phrase: string }) {
  const words = phrase.trim().split(/\s+/);
  return (
    <div
      data-testid="recovery-phrase-grid"
      className="grid grid-cols-3 gap-x-3 gap-y-2 p-3"
      style={{
        backgroundColor: 'var(--paper-2)',
        border: '1px solid var(--ink)',
      }}
    >
      {words.map((word, i) => (
        <div key={i} className="flex items-baseline gap-1.5">
          <span
            className="font-mono tabular-nums w-4 text-right"
            style={{ fontSize: 10, color: 'var(--over-num)', fontWeight: 700 }}
          >
            {i + 1}
          </span>
          <span
            data-testid="recovery-phrase-word"
            className="font-mono select-all"
            style={{ fontSize: 12, color: 'var(--ink)' }}
          >
            {word}
          </span>
        </div>
      ))}
    </div>
  );
}
